export const endpoints = {
  auth: {
    signIn: `/student-auth/v1/sign-in`,
    validate: `/student-auth/v1/validate`,
    revoke: `/student-auth/v1/revoke`,
    activateStart: `/student-auth/v1/activate/start`,
    activateAnswer: `/student-auth/v1/activate/answer`,
    telegramStart: `/student-auth/telegram/start`,
    telegramPoll: (loginId: string) => `/student-auth/telegram/poll/${loginId}`,
    telegramSelect: `/student-auth/telegram/select`,
  },
  user: {
    me: `/student/me`,
    sessions: `/student/sessions`,
    password: `/student/password`,
    profilePicture: `/student/profile-picture`,
    cancelPendingProfilePicture: `/student/profile-picture/pending`,
    terminateSession: (id: number) => `/student/sessions/${id}`,
    profileDocumentContent: (id: string) =>
      `/student/profile-documents/${id}/content`,
  },
  suggestions: {
    submit: `/student/suggestions`,
  },
  calendar: {
    month: (year: number, month: number) =>
      `/student/calendar?year=${year}&month=${month}`,
    challenge: `/student/calendar/challenge`,
  },
  notifications: {
    list: `/student/notifications`,
    read: `/student/notifications/read`,
    readAll: `/student/notifications/read-all`,
  },
  audios: {
    list: `/student/audios`,
  },
  dashboard: {
    current: `/student/dashboard`,
  },
  group: {
    current: `/student/group`,
    history: `/student/group/history`,
  },
  invoices: {
    list: `/student/invoices`,
    history: `/student/invoices/history`,
  },
  payments: {
    list: `/student/payments`,
    history: `/student/payments/history`,
  },
  performance: {
    current: `/student/performance`,
  },
  attendance: {
    history: `/student/attendance/history`,
  },
  cashierRewards: {
    list: `/student/cashier-actions/rewards`,
    update: (id: number) => `/student/cashier-actions/rewards/${id}`,
    history: `/student/cashier-actions/rewards/history`,
  },
  cashierAttendance: {
    list: `/student/cashier-actions/attendance`,
    upsert: `/student/cashier-actions/attendance`,
    remove: `/student/cashier-actions/attendance`,
  },
  rewards: {
    history: `/student/rewards/history`,
  },
  streak: {
    daily: `/student/streak`,
    submit: `/student/streak/submit`,
    answer: `/student/streak/answer`,
    leaderboard: `/student/streak/leaderboard`,
    practice: `/student/streak/practice`,
    practiceAnswer: `/student/streak/practice/answer`,
    practiceStats: `/student/streak/practice/stats`,
    speaking: `/student/streak/speaking`,
    speakingAnswer: `/student/streak/speaking/answer`,
    weeklyResults: `/student/streak/weekly-results`,
    weeklyResultsSeen: `/student/streak/weekly-results/seen`,
  },
  rating: {
    cycles: `/student/rating/cycles`,
    questions: (id: number) => `/student/rating/cycles/${id}/questions`,
    submit: `/student/rating`,
  },
  groupAssignments: {
    list: `/student/group-assignments/history`,
  },
  push: {
    publicKey: `/student/push/public-key`,
    subscribe: `/student/push/subscribe`,
    test: `/student/push/test`,
  },
};
